import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'DOGECEO Swap',
  description:
    "Doge CEO a Meme token in the BSC ecosystem, $DOGECEO is comunity-driven cannot control by anyone.",
  image: 'images/logo.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('DOGECEO Swap')}`,
      }
    case '/swap':
      return {
        title: `${t('Swap')} | ${t('DOGECEO Swap')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('DOGECEO Swap')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('DOGECEO Swap')}`,
      }
    case '/pool':
      return {
        title: `${t('Pool')} | ${t('DOGECEO Swap')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('DOGECEO Swap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('DOGECEO Swap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('DOGECEO Swap')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('DOGECEO Swap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('DOGECEO Swap')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('DOGECEO Swap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('DOGECEO Swap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('DOGECEO Swap')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('DOGECEO Swap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('DOGECEO Swap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('DOGECEO Swap')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('DOGECEO Swap')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('DOGECEO Swap')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('DOGECEO Swap')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('DOGECEO Swap')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('DOGECEO Swap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('DOGECEO Swap Info & Analytics')}`,
        description: 'View statistics for DOGECEO Swap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('DOGECEO Swap Info & Analytics')}`,
        description: 'View statistics for DOGECEO Swap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Pools')} | ${t('DOGECEO Swap Info & Analytics')}`,
        description: 'View statistics for DOGECEO Swap exchanges.',
      }
    default:
      return null
  }
}
